<template>

  <header class="relative flex justify-end items-center h-auto w-full z-[1006] antialiased font-sans px-4">
    <div class="w-full mx-auto flex justify-between items-center">
      <!-- logo -->
      <div class="px-4 flex justify-items items-center">
        <a class="inline-block" href="/">
          <img class="h-[42px] my-auto" src="@/assets/header_logo.png" alt="SparkPROXY">
        </a>
        <div class="sm:hidden">
          <button @click="isVisible = !isVisible" type="button" class="block text-gray-500 hover:text-white focus:text-white focus:outline-none">
            <svg class="h-6 w-6 fill-current" viewBox="0 0 24 24">
              <path v-if="isVisible" fill-rule="evenodd" d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z"/>
              <path v-if="!isVisible" fill-rule="evenodd" d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"/>
            </svg>
          </button>
        </div>
      </div>

      <div class="flex items-center">
        <div class="language-switch" aria-label="Language switch">
          <button
            type="button"
            :class="['language-switch__item', {'is-active': currentLanguage === 'zh-cn'}]"
            @click="changeLanguage('zh-cn')"
          >中文</button>
          <span class="language-switch__divider">/</span>
          <button
            type="button"
            :class="['language-switch__item', {'is-active': currentLanguage === 'en'}]"
            @click="changeLanguage('en')"
          >EN</button>
        </div>
        
        <AccountDropdown :usercenter="true" class="sm:block sm:ml-6 z-10"/>
      </div>
    </div>

    <!--quick group-->
    <div v-if="!simple" class="fixed bottom-[119px] right-[25px] z-999999999">
      <div class="btn-list">
        <a v-if="showGoTop" href="javascript:void(0);" @click="scrollToTop" rel="nofollow" class="relative flex justify-center items-center mt-[36px] w-[50px] h-[50px] rounded-full border-0 bg-[#fff]">
          <img v-show="atTop" src="@/assets/index/img/index/right_top_no_icon.svg" alt="" class="no">
          <img v-show="!atTop" src="@/assets/index/img/index/right_top_act_icon.svg" alt="" class="hov">
        </a>
        <a href="#"
          class="group relative flex justify-center items-center mt-[36px] w-[50px] h-[50px] rounded-full border-0 text-white shadow-[0px_4px_20px_#3c457633]" 
          style="background: linear-gradient(138deg, #2e6062, #69a971);"
          @mouseenter="isQrCardVisible = true" @mouseleave="isQrCardVisible = false">
          <img src="@/assets/index/img/index/right_wechat_icon.svg" alt="">
          <transition name="fade">
            <qr-card class="qr-card-panel" v-if="isQrCardVisible"/>
          </transition>
        </a>
        <a href="javascript:void(0);" @click.prevent="openWechatQr"
          class="group relative flex justify-center items-center mt-[36px] w-[50px] h-[50px] rounded-full border-0 text-white shadow-[0px_4px_20px_#3c457633]" 
          style="background: linear-gradient(138deg, #2e6062, #69a971);">
          <img src="@/assets/index/img/index/right_email_icon.svg" alt="">
        </a>
        <a href="https://t.me/+QTlIZobvM0wwMTZl" target="_blank" 
          class="group relative flex justify-center items-center mt-[36px] w-[50px] h-[50px] rounded-full border-0 text-white shadow-[0px_4px_20px_#3c457633]" 
          style="background: linear-gradient(138deg, #2e6062, #69a971);">
          <img src="@/assets/index/img/index/right_telegram_icon.svg" alt="">
          <div class="absolute bottom-0 left-[50%] transform translate-x-[-50%] translate-y-[100%] w-auto text-[12px] text-[#3A9AE7] leading-[20px] hidden group-hover:inline-block">Telegram</div>
        </a>
      </div>
    </div>
  </header>
</template>

<script>
import FlyMenuItem from './FlyMenuItem.vue'
import AccountDropdown from './AccountDropdown'
import elementLocale from 'element-ui/lib/locale';
import localeZH from 'element-ui/lib/locale/lang/zh-CN'; 
import localeEN from 'element-ui/lib/locale/lang/en'; 
import { setLang } from '@/http/api/home'
import { cookieAuthEnabled } from '@/http/authMode'
import QrCard from '@/components/qr-card.vue';

export default {
  name: 'UserConterHeaderBar',
  components: {
    FlyMenuItem,
    AccountDropdown,
    QrCard,
  },
  data() {
    return {
      atTop: true,
      isVisible: false,
      showGoTop: false,
      isQrCardVisible: false,
    }
  },
  props: {
    simple: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentLanguage() {
      return this.$i18n.locale;
    },
  },
  mounted() {
    this.checkScroll();
    window.addEventListener('scroll', this.checkScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.checkScroll);
  },
  methods: {
    changeLanguage(lang) {
      if (this.$i18n.locale !== lang) {
        this.$i18n.locale = lang;
        elementLocale.use(this.$i18n.locale === 'zh-cn' ? localeZH : localeEN);
        let oldLang = localStorage.getItem('language');
        localStorage.setItem('language', lang);

        if (!cookieAuthEnabled) {
          setLang({lang}).catch(e => { console.log(e) });
        }

        window.dispatchEvent(new StorageEvent('storage', {
          key: 'language',
          newValue: lang,
          oldValue: oldLang,
          url: window.location.href
        }));
      }
    },
    openWechatQr() {
      window.dispatchEvent(new CustomEvent('open-wechat-qr'));
    },
    getImg(area) {
      return require(`@/assets/index/img/${area}`);
    },
    getAreaImg(area) {
      return require(`@/assets/index/img/index/img_${area}.png`);
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      this.atTop = true;
    },
    checkScroll() {
      this.atTop = window.scrollY === 0;
      this.showGoTop = window.scrollY > 1000;
    },
  }
}
</script>

<style lang="scss" scoped>
  .btn-list a::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: rgba(46,79,237,.12);
    transform: translate(-50%, -50%) scale(0);
    transition: transform 0.3s ease-in-out;
    z-index: -1;
  }

  .btn-list a:hover::after {
    transform: translate(-50%, -50%) scale(1.2);
  }

  .qr-card-panel {
    position: absolute;
    left: -20px;                  
    top: 50%;
    transform: translate(-100%, -50%);
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.6s ease;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .language-switch {
    display: inline-flex;
    align-items: center;
    height: 28px;
    padding: 0 8px;
    border-radius: 999px;
    color: #5d6675;
    font-size: 13px;
    line-height: 18px;
    opacity: 0.82;
  }

  .language-switch__item {
    appearance: none;
    border: 0;
    padding: 0 4px;
    background: transparent;
    color: currentColor;
    cursor: pointer;
    font: inherit;
    font-weight: 500;
    opacity: 0.62;
    transition: opacity 0.2s ease, color 0.2s ease;
  }

  .language-switch__item:hover,
  .language-switch__item.is-active {
    opacity: 1;
  }

  .language-switch__item.is-active {
    font-weight: 700;
    color: #0f3d3f;
  }

  .language-switch__divider {
    color: currentColor;
    opacity: 0.3;
    padding: 0 2px;
    user-select: none;
  }
</style>
